// Scrollbar appearance only. Containers declare their own sizing and overflow.
export const thinScrollbarStyles = {
  // Styles for WebKit browsers (Chrome, Safari, newer versions of Edge)
  '&::-webkit-scrollbar': {
    width: '10px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '5px',
    border: '2px solid transparent',
    backgroundClip: 'padding-box',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  // Styles for Firefox
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
  // Styles for Internet Explorer and legacy Edge
  msOverflowStyle: 'none',
  // Custom property for JavaScript detection
  // CSS variables must stay as kebab-case with -- prefix, enclosed in quotes
  '--scrollbar-width': '10px',
};

export const hiddenScrollbarStyles = {
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
};

const boxStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: 2,
  color: 'textColors.brand',
  height: '200px',
};
